import $ from 'jquery';
import _ from 'underscore';
// import { crossPageSelectHeadRow } from '@bingads-webui/projection-grid-cross-page-select-all';

import { getGridColumnsConfig } from './common/view/product-groups-columns';

export function getConfig({
  view,
  filterService,
  deps,
  dataSource,
  viewport,
  customHeaderOffset,
  isTreeView,
}) {
  const tableName = deps.i18n.getString('ProductGroupsGridName');
  const gridConfig = {
    name: 'newProductGroupsGrid',
    legacyGridName: 'newProductGroupsGrid',
    config: deps.config,
    tableClasses: ['table', 'table-bordered'],
    tableAttributes: { 'aria-label': tableName },
    filterService,
    dataSource,
    scrolling: {
      virtualized: true,
      header: {
        type: 'sticky',
        offset: customHeaderOffset || (() => $('nav.navbar-default.navbar-fixed-top').height()),
      },
    },
    rows: ['column-header-rows'],
    columns: getGridColumnsConfig(deps, view, isTreeView),
    selection: isTreeView ? {
      selectable: (item) => {
        if (_.isEmpty(item)) {
          return true;
        }
        return item && item.isAggregateRow !== true;
      },
    } : true,
  };

  if (viewport) {
    gridConfig.scrolling.viewport = viewport;
  }

  return gridConfig;
}
